import AsyncComponent from '../components/HOC/AsyncComponent';

const AsyncLoginMain = AsyncComponent(() => import('./LoginMain'));
const AsyncDashboard = AsyncComponent(() => import('./Dashboard'));
const AsyncResetPassword = AsyncComponent(() => import('./ResetPassword'));
const AsyncNotFound = AsyncComponent(() => import('./EmptyPage'));
const AsyncTermsAndConditionsOfUse = AsyncComponent(() =>
  import('./TermsAndConditionsOfUse')
);

export {
  AsyncLoginMain,
  AsyncDashboard,
  AsyncTermsAndConditionsOfUse,
  AsyncResetPassword,
  AsyncNotFound,
};



// WEBPACK FOOTER //
// ./src/pages/index.js